export var UserPartnershipApplicationStatus;
(function (UserPartnershipApplicationStatus) {
    /**
     * 접수 대기, 작성중
     */
    UserPartnershipApplicationStatus["PENDING"] = "pending";
    /**
     * 접수중, 제출 완료
     */
    UserPartnershipApplicationStatus["PROGRESSING"] = "progressing";
    /**
     * 보완필요
     */
    UserPartnershipApplicationStatus["REVISE"] = "revise";
    /**
     * 완료
     */
    UserPartnershipApplicationStatus["COMPLETED"] = "completed";
})(UserPartnershipApplicationStatus || (UserPartnershipApplicationStatus = {}));
